import { render, staticRenderFns } from "./WebSponsorProcess.vue?vue&type=template&id=9ad48078&scoped=true"
import script from "./WebSponsorProcess.vue?vue&type=script&lang=js"
export * from "./WebSponsorProcess.vue?vue&type=script&lang=js"
import style0 from "./WebSponsorProcess.vue?vue&type=style&index=0&id=9ad48078&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad48078",
  null
  
)

export default component.exports